import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { PreliminariesReportFilterModel } from 'src/app/models/preliminaries/preliminaries-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreliminariesReportService {

  private readonly _httpClient = inject(HttpClient);

  exportPreliminariesReportPendingOrder(preliminariesReportFilter: PreliminariesReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.preliminariesReport.ExportPreliminariesReportPendingOrder}`, preliminariesReportFilter, {
      responseType: 'blob',
    });
  }

  getPreliminariesReportPendingOrder(preliminariesReportFilter: PreliminariesReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.preliminariesReport.PreliminariesReportPendingOrder}`, preliminariesReportFilter);
  }
}


